import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import Table from '../Table/Table';
import { getTranslation } from '../../../../utils/translation';
import styles from './PopularEvents.module.scss';

const PopularEvents = () => {
    const popularEvents = useSelector(state => state.sportEvents.popularEvents);

    const [isExpanded, setIsExpanded] = useState(true);

    if (!popularEvents?.length) return null;

    return (
        <div className={styles.popularEvents}>
            <div className={styles.header} onClick={() => setIsExpanded(prev => !prev)}>
                <div className={styles.title}>
                    <span className={'icon-star'} />
                    <span>{getTranslation('popularEvents')}</span>
                    <span className={styles.count}>{popularEvents.length}</span>
                </div>
                <span
                    className={classnames(styles.arrowIcon, 'icon-arrow-down', {
                        [styles.collapsed]: !isExpanded,
                    })}
                />
            </div>
            <div className={classnames(styles.content, { 'd-hidden': !isExpanded })}>
                <Table events={popularEvents} />
            </div>
        </div>
    );
};

export default PopularEvents;
